import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface ThreeDotsIconProps {
  primaryColor?: string;
  secondaryColor?: string;
  size?: number;
  [x: string]: unknown;
}

const ThreeDotsIcon = ({ primaryColor, secondaryColor, size = 24, ...rest }: ThreeDotsIconProps) => {
  const { token } = useToken();

  const primary = primaryColor ?? token.colorBorder;
  const secondary = secondaryColor ?? '#223348';

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Icon / 3DotsTwoTone">
        <path
          id="Vector"
          d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
          fill={primary}
        />
        <circle id="Ellipse 1" cx="12" cy="12" r="8.72" fill={secondary} />
        <path
          id="Vector_2"
          d="M10.875 12C10.875 12.2984 10.9935 12.5845 11.2045 12.7955C11.4155 13.0065 11.7016 13.125 12 13.125C12.2984 13.125 12.5845 13.0065 12.7955 12.7955C13.0065 12.5845 13.125 12.2984 13.125 12C13.125 11.7016 13.0065 11.4155 12.7955 11.2045C12.5845 10.9935 12.2984 10.875 12 10.875C11.7016 10.875 11.4155 10.9935 11.2045 11.2045C10.9935 11.4155 10.875 11.7016 10.875 12Z"
          fill={primary}
        />
        <path
          id="Vector_3"
          d="M15.5625 12C15.5625 12.2984 15.681 12.5845 15.892 12.7955C16.103 13.0065 16.3891 13.125 16.6875 13.125C16.9859 13.125 17.272 13.0065 17.483 12.7955C17.694 12.5845 17.8125 12.2984 17.8125 12C17.8125 11.7016 17.694 11.4155 17.483 11.2045C17.272 10.9935 16.9859 10.875 16.6875 10.875C16.3891 10.875 16.103 10.9935 15.892 11.2045C15.681 11.4155 15.5625 11.7016 15.5625 12ZM6.1875 12C6.1875 12.2984 6.30603 12.5845 6.517 12.7955C6.72798 13.0065 7.01413 13.125 7.3125 13.125C7.61087 13.125 7.89702 13.0065 8.108 12.7955C8.31897 12.5845 8.4375 12.2984 8.4375 12C8.4375 11.7016 8.31897 11.4155 8.108 11.2045C7.89702 10.9935 7.61087 10.875 7.3125 10.875C7.01413 10.875 6.72798 10.9935 6.517 11.2045C6.30603 11.4155 6.1875 11.7016 6.1875 12Z"
          fill={primary}
        />
      </g>
    </svg>
  );
};

export default ThreeDotsIcon;
